var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBaselineArrowLeft24Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 2195",
    d: "M24 0H0v24h24z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Arrow - Right",
    d: "M3.781 12.227V12.268a.832.832 0 00.195.315l6.6 6.67a.809.809 0 001.174.002.839.839 0 00.077-1.081l-.077-.092-5.2-5.252h14.382a.831.831 0 00.111-1.653l-.111-.007H6.55l5.2-5.251a.839.839 0 000-1.175.809.809 0 00-1.065-.083l-.092.08-6.602 6.67A.835.835 0 003.75 12a.844.844 0 00.031.227z",
    fill: "#00000e"
  })));
}
export default SvgBaselineArrowLeft24Px;